import React from "react"
import LoanProduct from "../../../components/LoanProducts"
import PersonalLoan from "../../../assets/Images/component/personalLoan.png"
import MedicalLoan from "../../../assets/Images/component/medicalLoan.png"
import ShoppingLoan from "../../../assets/Images/component/shoppingLoan.png"
import ContactIcon from "../../../assets/Images/component/contactIcon.svg"
import MedicalIcon from "../../../assets/Images/component/medicalIcon.svg"
import ShoppingIcon from "../../../assets/Images/component/shoppingIcon.svg"
import Scroller from "../../../components/Slider/Scroller"
const personalLoanList = [
  "Get Renovation Loan for upto 16%.",
]
const Products = [
  {
    title: "Personal Loan",
    icon: ContactIcon,
    image: PersonalLoan,
    list: personalLoanList,
    color: {
      iconBg: "#DECEE5",
      contentBg: "#DECEE5",
      borderColor: "#6F4C9F",
    },
  },
  {
    title: "Medical Loan",
    icon: MedicalIcon,
    image: MedicalLoan,
    list: personalLoanList,
    color: {
      iconBg: "#F0EFA2",
      contentBg: "#F0EFA254",
      borderColor: "#AB882E",
    },
  },
  {
    title: "Shopping Loan",
    icon: ShoppingIcon,
    image: ShoppingLoan,
    list: personalLoanList,
    color: {
      iconBg: "#F8AFBA",
      contentBg: "#FDEBED",
      borderColor: "#9BD7D0",
    },
  },
]
const LoanProductSection = () => {
  return (
    <div className="mt-[60px] md:mt-[120px]">
      <p className="font-Apparat font-[700] text-[20px] md:text-[32px] leading-[40px] tracking-[-2%] mb-[22px]">
        Loan Products
      </p>

      <Scroller>
        {Products?.map((item, index) => (
          <LoanProduct
            containerStyle="min-w-[200px] lg:flex-shrink-0"
            key={index}
            icon={item?.icon}
            title={item?.title}
            thumbnail={item?.image}
            list={item?.list}
            color={item?.color}
          />
        ))}
      </Scroller>
    </div>
  )
}

export default LoanProductSection
